import {NgModule} from '@angular/core';
import {SaleRoutingModule} from '@app/modules/sale/sale-routing.module';

@NgModule({
  imports: [SaleRoutingModule]
})
export class SaleModule {
}
